module.exports = __webpack_public_path__ + "static/media/Garantia_Bravecto_2026.4e5eeeea.pdf";